import { Component, OnInit } from '@angular/core';
import {SeoService} from '../../../../services/seo/seo.service';

@Component({
  selector: 'app-pali-buddist-assoc',
  templateUrl: './pali-buddist-assoc.component.html',
  styleUrls: ['./pali-buddist-assoc.component.scss']
})
export class PaliBuddistAssocComponent implements OnInit {

  constructor(private seo: SeoService) { }

  ngOnInit(): void {
    this.seo.setMeta('Association of Pali and Buddhist Studies');
  }

}
